<template>
  <div class="clearfix mobile-header">
    <div class="mobile-side-menu" v-if="userInfo.username">

      <dl v-for="menu, index in sideMenu" v-if="step == '1'">
        <dt v-if="index === 0">{{menu.title}}</dt>
        <dt v-if="index === 1">{{userInfo.username}}</dt>
        <dd>
          <ul>
            <li v-if="index ===1 && userInfo.has_single == 1" @click="step = 2"><a>下单账户<i class="el-icon-arrow-right"></i></a></li>
            <li v-for="item in menu.list" v-if="item.url != '/buyer/dashboard'">
              <a :href="item.url" @click="selectMenu()">
                {{item.label}}
                <i class="el-icon-arrow-right" v-if="item.url != '/logout'"></i>
              </a>
            </li>
            <li v-if="index ===1" @click="logout()">退出</li>
          </ul>
        </dd>
      </dl>
      <dl v-if="step == '2'">
        <dt @click="step = '1'"><span style="font-size:18px;">&lt;</span> 下单账户</dt>
        <dd>
          <ul>
            <li v-for="item in singleMenu">
              <a :href="item.url" @click="selectMenu()">
                {{item.label}}
                <i class="el-icon-arrow-right" v-if="item.url != '/logout'"></i>
              </a>
            </li>
            <li @click="logout()">退出</li>
          </ul>
        </dd>
      </dl>
    </div>
    <div class="mobile-side-menu" v-if="!userInfo.username">
      <dl>
        <dt>Joyorders</dt>
        <dd>
          <ul>
            <li>
              <a @click="selectMenu()" href="/MerchantList">
                商家
                <i class="el-icon-arrow-right"></i>
              </a>
            </li>
            <!--<li>
              <a @click="getGoods()" href="javascript:void(0);">
                丝芙兰
                <i class="el-icon-arrow-right"></i>
              </a>
            </li>-->
            <li>
              <a @click="selectMenu()" href="/TaskMarket">
                任务市场
                <i class="el-icon-arrow-right"></i>
              </a>
            </li>
            <!-- <li>
              <a @click="selectMenu()" href="https://bbs.joyorders.com">
                论坛
                <i class="el-icon-arrow-right"></i>
              </a>
            </li> -->
            <li>
              <a @click="selectMenu()" href="/HelpCenter">
                帮助中心
                <i class="el-icon-arrow-right"></i>
              </a>
            </li>
          </ul>
        </dd>
      </dl>
      <dl>
        <dt>首页</dt>
        <dd>
          <ul>
            <li>
              <a @click="showGlobalDialog('loginVisible')">
                登录
                <i class="el-icon-arrow-right"></i>
              </a>
            </li>
            <li>
              <a @click="showGlobalDialog('registerVisible')">
                注册
                <i class="el-icon-arrow-right"></i>
              </a>
            </li>
          </ul>
        </dd>
      </dl>
    </div>
    <div class="left-menu float-left">
      <ul @click="toggleSideMenu()">
        <li></li>
        <li></li>
        <li></li>
      </ul>
    </div>
    <div class="logo float-left"><a href="/"><img style="" src="../assets/images/mobilelogo.png"></a></div>
    <div class="right-menu float-left">
      <div class="float-right gray-txt">
        <a href="/cart" class="icon-shopping-cart icon mobileShopping">
          <span v-if="cartCount > 0">{{cartCount}}</span>
        </a>
      </div>
      <div style="margin-right: 15px;" class="float-right gray-txt">
        <a :href="messageUrl" v-if="userInfo.username" class="icon-bell icon mobilebell">
          <span v-if="totalCount > 0">{{totalCount}}</span>
        </a>
      </div>
      <div style="margin-right: 16px; cursor:pointer;" class="float-right small-search" @click="showSearch()">
        <i class="el-icon-search"></i>
      </div>
      
    </div>
    <div class="mobile-side-search" v-if="showSearchBar">
      <div>
        <el-row class="head">
          <el-col :span="3">
            <i class="el-icon-arrow-left" style="cursor:pointer;" @click="hideSearch()"></i>
          </el-col>
          <el-col :span="21">
          <input type="text" class="input" placeholder="请输入要搜索的内容..."  v-model="keyword"  @input="input()">
          
          </el-col>
        </el-row>
        <div class="line"></div>
        <div class="searchList" v-if="showSearchList">
            <ul>
              <li v-for="item in searchList" v-if="showBusiness" @click="getGoodsList(item)">{{item.name + '——' +item.website}}</li>
              <li v-for="item in searchList" v-if="showGoods" @click="getGoodDetail(item)">{{item.name}}</li>
              <li @click="searchInSephora()" v-if="keyword">在丝芙兰中搜索商品</li>
              <li @click="searchInCurrency('Nordstrom')" v-if="keyword">在Nordstrom中搜索商品</li>
              <li @click="searchInCurrency('JoyOrders')" v-if="keyword">在Joyorders自营店中搜索商品</li>
            </ul>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import { USERMENU, SINGLESIDEMENU } from '../services/constant.js'
import api from '../services/api.js'
let _ = require('lodash')
let $ = require('jQuery')

export default {
  name: 'MobileHeader',
  props: ['userInfo', 'messageUrl', 'totalCount'],
  created () {
    $('.global-modal').on('click', function () {
      $('body').removeClass('show-mobile-side-menu')
    })
    this.getCartList()
  },
  components: {
  },
  data () {
    return {
      showSearchBar: false,
      step: '1',
      sideMenu: [
        {
          title: '首页',
          list: [
            {label: '商家', url: '/MerchantList'},
            //{label: '丝芙兰', url: '/items/45'},
            {label: '任务市场', url: '/TaskMarket'},
            // {label: '论坛', url: 'https://bbs.joyorders.com'},
            {label: '帮助中心', url: '/HelpCenter'}
          ]
        },
        {
          title: this.userInfo,
          list: USERMENU
        }
      ],
      cartCount: 0,
      singleMenu: [
        {label: '概览', url: '/buyer/dashboard'},
        {label: '发起任务', url: '/buyer/publish_task/cart'},
        {label: '我的任务', url: '/buyer/task/list'},
        {label: '收支明细', url: '/buyer/income'},
        {label: '提现方式', url: '/buyer/withdraw'},
      ],
      keyword: '',
      searchList: null,
      showSearchList: false,
      showBusiness: true,
      showGoods: false
    }
  },
  mounted(){
        document.body.addEventListener('click', () => {
            this.showSearchList = false
        }, false)
    },
  computed: {
    globalDialog () {
	    return this.$store.state.globalDialog
    }
  },
  methods: {
    async logout(){
      let res = await api.post(this, {
        path: 'passport.php',
        api: 'logout'
      })
      this.$localStorage.remove('token')
      this.$localStorage.remove('openid')
      this.$localStorage.remove('username')
      this.$localStorage.remove('taskInfo')
      this.$localStorage.remove('account_id')
      this.$localStorage.remove('goBackOrderUrl')
      sessionStorage.removeItem('isSingle')
      sessionStorage.removeItem('has_shipping_manager')
      location.reload()
    },
    async getCartList () {
      if(!window.localStorage.getItem('token')) return
      let res = await api.getCartList(this)
      let list = []
      if (res.body.result) {
        list = res.body.result
      }
      this.cartCount = 0
      _.each(list, item => {
        if (item && item.status == '0') {
          this.cartCount += Number(item.number)
        }
      })
    },

    // 滚动到下单人
    scrolltobueyer () {
      $('body').removeClass('show-mobile-side-menu')
      if (this.pathname != 'home') {
        this.$router.push('/')
      }
      document.querySelector('.buyer').scrollIntoView(false)
    },
    toggleSideMenu () {
      let $app = $('body')
      let className = 'show-mobile-side-menu'
      if ($app.hasClass(className)) {
        $app.removeClass(className)
      } else {
        $app.addClass(className)
      }
    },
    showSearch () {
      this.showSearchBar = true
    },
    hideSearch () {
      this.showSearchBar = false
    },
    selectMenu () {
      this.step = '1'
      $('body').removeClass('show-mobile-side-menu')
    },
    getGoods () {
      this.step = '1'
      $('body').removeClass('show-mobile-side-menu')
      this.$router.push({name: 'Goods', params: {id: 'SephoraUS'}})
    },
    showGlobalDialog (type) {
      this.selectMenu()
      this.$store.commit('showGlobalDialog', type)
    },
    async input () {
      if(!this.keyword){
        this.showSearchList = false
      }else{
        let parmas = {
          name: this.keyword
        }
          let res = await api.serchBusinessList(this, parmas)
          if(res.body.status == 'ok'){
            if(res.body.result){
              this.searchList = res.body.result
              this.showBusiness = true
              this.showGoods = false
              this.showSearchList = true
            }else{
              let good = await api.serchGoodsList(this, parmas)
              if(good.body.result.length > 0) {
                if(good.body.result.length > 1) {
                  this.searchList = good.body.result
                  this.showGoods = true
                  this.showBusiness = false
                  this.showSearchList = true
                }else{
                  this.$router.push({name:'Item', params:{id:good.body.result[0].id}})
                }
              }
            }
              console.log(this.searchList)
          }
      }
    },
    searchInSephora () {
      localStorage.setItem('SearchKeyword', this.keyword)
      this.$router.push({name:'Goods', params:{id:'SephoraUS'}})
      this.hideSearch()
    },
    searchInCurrency (id) {
      localStorage.setItem('SearchKeyword', this.keyword)
      this.$router.push({name:'NormalProduct', params:{id:id}})
      this.hideSearch()
    },
    getGoodsList (item) {
        this.$router.push({name: 'Merchant', params: {id: item.tag}})
      this.hideSearch()
    },
    getGoodDetail(item) {
        this.$router.push({name:'Item', params:{id:item.id}})
      this.hideSearch()
    }
  },
  watch: {
    'globalDialog.cartChangeVisible' (val, oldVal) {
      this.getCartList()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.mobile-header {
  position: relative;
  .left-menu {
    width: 35%;
    ul {
      width:20px;
    }
    li {
      width:20px;
      height:2px;
      background-color: #888;
      &:first-child {
        margin-bottom: 4px;
      }
      &:last-child {
        margin-top: 4px;
      }
    }
  }
  .right-menu {
    width: 35%;

    .mobileShopping {
      font-size: 17px;
    }
    .mobilebell {
      font-size: 15px;
    }
  }
  .logo {
    width: 30%;
    font-size:13px;
    text-align: center;
    a {
      color: #000;
      font-family:Impact;
    }
  }

  .mobile-side-menu {
    width: 227px;

    dl {
      &:last-child {
        padding-top: 20px;
      }
    }

    dt {
      font-size: 12px;
      margin-bottom: 5px;
    }
    li {
      padding: 12px 0;
      border-bottom: 1px solid #E1E1E1;
      &:last-child {
        border-bottom: none;
      }
    }
    a {
      font-size: 14px;
      color: #333;
      display: block;

      .el-icon-arrow-right {
        float: right;
        font-size: 8px;
        position: relative;
        top: 3px;
      }
    }
  }

  .mobile-side-search {
    position: fixed;
    z-index: 9999;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    height: 100vh;

    .head {
      padding: 10px;

      input {
        border: none;
        width: 100%;
        height: 30px;
      }
    }
      .searchList {
        position: absolute;
        border: 1px solid #e4e7ed;
        border-radius: 4px;
        background-color: #fff;
        max-height: 600px;
        overflow-y: scroll;

        &::-webkit-scrollbar {/*滚动条整体样式*/
            width: 0px;     /*高宽分别对应横竖滚动条的尺寸*/
            height: 1px;
        }
        &::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
            border-radius: 10px;
            background: rgba(144,147,153,.3);
        }
        &::-webkit-scrollbar-track {/*滚动条里面轨道*/
            border-radius: 10px;
        }
        li {
          font-size: 14px;
          padding: 10px 20px;
          position: relative;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: #606266;
          height: 54px;
          line-height: 34px;
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
          cursor: pointer;
          &+li {
            border-top: 1px solid #cdcdcd;
          }
          &:hover {
            color: #ffffff !important;
            background: #333333;
          }
        }
      }

    .line {
      width: 100%;
      height: 1px;
      background: #ddd;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MobileHeader.vue